import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import AppContext from '../../../app/context'
import buildStyles from './styles'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import { useWindowSize } from '../../../hooks/useWindowSize'

const Footer = () => {
  const { state } = useContext(AppContext)

  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
    isMobile: isMobile,
  })

  return (
    <Box className={styles.footer}>
      <a
        className={styles.footerText}
        href="https://goodwillbox.pl/"
        target="blank"
      >
        Powered by GoodWillBox
      </a>
    </Box>
  )
}

export default Footer
